<!-- Close Button -->
<button data-id="modal-close-button" mat-icon-button mat-dialog-close class="close-button">
  <mat-icon>close</mat-icon>
</button>

<!-- Breadcrumbs -->
<div class="modal-header">
  <h4 class="modal-title">
    <span [ngClass]="{'enable-ellipsis': level.useEllipsis}"
      *ngFor="let level of parents$ | async; last as last">
      <span [ngClass]="{'ellipsis-block': level.useEllipsis}"
        [attr.title]="level.useEllipsis ? (level.label || level._id) : null"
        *ngIf="level.cont_type === 'group' || last">
        {{ level.label || level._id }}
      </span>
      <a  [ngClass]="{'ellipsis-block': level.useEllipsis}"
        [attr.title]="level.useEllipsis ? (level.label || level._id) : null"
        *ngIf="level.cont_type !== 'group' && !last"
        (click)="containerLevel(level.cont_type, level._id)">
        {{ level.label || level._id }}
      </a>
      <fw-icon *ngIf="!last" size="small" color="slate">chevron-forward</fw-icon>
    </span>
  </h4>
</div>

<!-- Body -->
<div mat-dialog-content>
  <!-- Browser -->
  <div class="hierarchy-browser">
    <!-- Files -->
    <ng-container *ngIf="!isOutput && files$ | async as files">
      <ng-container *ngIf="files.length > 0; else noFiles">
        <div class="browser-title">Files</div>
        <div *ngFor="let fileOption of files"
          (click)="selectedInput = fileOption"
          [ngClass]="{'selected': selectedInput?.file?.name === fileOption.file.name }"
          class="browser-row">
          <a class="file">
            <fw-icon *ngIf="fileOption.file.suggested[inputType] === true" size="small" color="slate">chevron-forward</fw-icon>
            {{ fileOption.file.name }}
          </a>
        </div>
        <button *ngIf="files.length >= (filesPage$ | async) * pageSize" type="button" mat-button
          (click)="filesPage$.next(filesPage$.value + 1)" class="load-more-button">Load More</button>
      </ng-container>
      <!-- if there are no files available on the lowest level -->
      <ng-template #noFiles>
        <div *ngIf="(children$ | async)?.total === 0" class="blank-state">
          <p>There are no files available.</p>
        </div>
      </ng-template>
    </ng-container>

    <!-- Children Containers -->
    <ng-container *ngIf="children$ | async as children">

      <!-- Acquisitions -->
      <ng-container *ngIf="children.acquisitions?.length > 0">
        <div class="browser-title">Acquisitions</div>
        <div *ngFor="let acquisition of children.acquisitions"
          (click)="isOutput && selectedOutput = acquisition"
          [ngClass]="{'input-cursor': !isOutput, 'selected': selectedOutput?._id === acquisition._id}"
          class="browser-row">
          <span>{{ acquisition.label || acquisition._id }}</span>
          <fw-icon *ngIf="!isOutput" (click)="containerLevel('acquisition', acquisition._id)" size="small" color="slate" class="position-right">chevron-forward</fw-icon>
        </div>
      </ng-container>
      <!-- End Acquisitions -->

      <!-- Sessions -->
      <ng-container *ngIf="children.sessions?.length > 0">
        <div class="browser-title">Sessions</div>
        <div *ngFor="let session of children.sessions"
          (click)="isOutput && selectedOutput = session"
          [ngClass]="{'input-cursor': !isOutput, 'selected': selectedOutput?._id === session._id}"
          class="browser-row">
          <span>{{ session.label || session._id }}</span>
          <fw-icon (click)="containerLevel('session', session._id)" size="small" color="slate" class="position-right">chevron-forward</fw-icon>
        </div>
      </ng-container>
      <!-- End Sessions -->

      <!-- Analyses -->
      <ng-container *ngIf="gearContext === 'analysis' && !isOutput && children.analyses?.length > 0">
        <div class="browser-title">Analyses</div>
        <div *ngFor="let analysis of children.analyses" class="browser-row input-cursor">
          <span>{{ analysis.label || analysis._id }}</span>
          <fw-icon (click)="containerLevel('analysis', analysis._id)" size="small" color="slate" class="position-right">chevron-forward</fw-icon>
        </div>
      </ng-container>

      <!-- Subjects -->
      <ng-container *ngIf="children.subjects?.length > 0">
        <div class="browser-title">Subjects</div>
        <div *ngFor="let subject of children.subjects" class="browser-row input-cursor">
          <span>{{ subject.label || subject._id }}</span>
          <fw-icon (click)="containerLevel('subject', subject._id)" size="small" color="slate" class="position-right">chevron-forward</fw-icon>
        </div>
      </ng-container>

      <!-- Projects -->
      <ng-container *ngIf="children.projects?.length > 0">
        <div class="browser-title">Projects</div>
        <div *ngFor="let project of children.projects" class="browser-row input-cursor">
          <span>{{ project.label || project._id }}</span>
          <fw-icon (click)="containerLevel('project', project._id)" size="small" color="slate" class="position-right">chevron-forward</fw-icon>
        </div>
      </ng-container>

      <!-- Collections -->
      <ng-container *ngIf="$any(children).collections?.length > 0">
        <div class="browser-title">Collections</div>
        <div *ngFor="let collection of $any(children).collections" class="browser-row input-cursor">
          <span>{{ collection.label || collection._id }}</span>
          <fw-icon (click)="containerLevel('collection', collection._id)" size="small" color="slate" class="position-right">chevron-forward</fw-icon>
        </div>
      </ng-container>

      <button *ngIf="children.total >= (childrenPage$ | async) * pageSize" type="button" mat-button
        (click)="childrenPage$.next(childrenPage$.value + 1)" class="load-more-button">Load More</button>

    </ng-container>
    <!-- End Children Containers -->
  </div>
</div>

<!-- Footer -->
<div class="modal-footer browser-modal-footer">
  <div class="pull-left" style="padding-top:6px;" *ngIf="!isOutput">
    <fw-icon size="small" color="slate" class="suggested-icon">chevron-forward</fw-icon> = Suggested file
  </div>
  <button *ngIf="!isOutput" type="submit" class="btn btn-primary"
    [disabled]="!selectedInput" (click)="submitSelection()">
    Select File
  </button>
  <!-- output workflow -->
  <button *ngIf="isOutput" type="submit" class="btn btn-primary"
    [disabled]="!selectedOutput" (click)="submitSelection()">
    Select Container
  </button>
</div>
